import { Redirect } from 'react-router-dom';

import analytics from '../lib/analytics';

const PageNotFound = () => {
  analytics.track('PAGE_NOT_FOUND');
  return <Redirect to='/' />;
};

export default PageNotFound;
